import styled from 'styled-components';

import shouldForwardProp from 'configs/shouldForwardProp';

import { TChipSize } from './Chip.types';

export const StyledChipList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

export const StyledChip = styled.span.withConfig({ shouldForwardProp })<{ $size: TChipSize }>`
  padding: ${({ $size }) => ($size === 'sm' ? '1px 8px' : '2px 8px')};
  border-radius: ${({ theme }) => theme.borderRadius.s}px;
  background-color: ${({ theme }) => theme.colors.surface};
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: ${({ theme }) => theme.fontSizes.s}px;
`;
